<div class="note-list-content" (click)="preventPanelClosing($event)">
    <!-- header -->
    <div class="notes-list-info">
        <div class="header-container">
            <span class="is-subtitle1" style="font-weight: 500; color: #000000">
                {{notesListTotal}}
            </span>
            <span *ngIf="notesListTotal === 1" class="is-subtitle1" style="font-weight: 500; color: #000000">
                {{'note' | translate | lowercase}}
            </span>
            <span *ngIf="notesListTotal !== 1" class="is-subtitle1" style="font-weight: 500; color: #000000">
                {{'notes' | translate | lowercase}}
            </span>
            <ng-container *ngIf="checkPermission('dataexperience.change_note')">
                <button *ngIf="dataExperienceGeneralNotes && checkPermission('dataexperience.add_note')" mat-button color="primary" (click)="addNewNote()"
                    [disabled]="showAddNote || showSpinner">
                    <mat-icon [svgIcon]="'add_note'"></mat-icon>
                    <span>{{'add' | translate | uppercase}}</span>
                </button>
            </ng-container>
            <!-- spinner -->
            <ng-container *ngIf="showSpinner">
                <mat-progress-spinner mode="indeterminate" [diameter]="30"></mat-progress-spinner>
            </ng-container>
        </div>
        <div>
            <button mat-icon-button color="primary" (click)="exportNoteList($event)"
                [disabled]="notesListTotal === 0 || showSpinner ? true : false"
                [matTooltip]="'export_excel' | translate">
                <mat-icon [svgIcon]="'export'"></mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="openFullScreeNoteList($event)" [disabled]="showSpinner"
                [matTooltip]="'open_fullscreen' | translate">
                <mat-icon [svgIcon]="'fullscreen'"></mat-icon>
            </button>
        </div>
    </div>

    <ng-container *ngIf="checkPermission('dataexperience.change_note')">
        <div class="new-note-container" *ngIf="showAddNote && !showSpinner">
            <is-create-note (createNote)="createNewGeneralNote($event)"
                (cancelNote)="closeShowAddNote($event)"></is-create-note>
            <mat-divider style="margin-bottom: 15px; margin-top: 15px;"></mat-divider>
        </div>
    </ng-container>

    <ng-container *ngIf="noteListGeneral.length === 0 && noteListHighlighted.length === 0 && !showSpinner">
        <div style="padding: 10px 20px 0 20px;">
            <span class="is-caption">{{'no_notes' | translate}}</span>
        </div>
    </ng-container>


    <div class="note-list-real" [ngStyle]="{'max-height': showAddNote ? '86px' : '425px'}">
        <!-- highlighted notes list -->
        <ng-container *ngIf="noteListHighlighted.length !== 0">
            <div class="highlighted-notes-header">
                <span class="is-subtitle1" style="font-weight: 500; color: #000000">
                    {{'highlighted_notes' | translate}}
                </span>
            </div>
            <!-- <mat-divider class="divider-highlighted"></mat-divider> -->
        </ng-container>
        <ng-container *ngIf="noteListHighlighted.length !== 0">
            <div style="padding-top: 20px;" class="highlighted-notes-content">
                <div *ngFor="let note of noteListHighlighted; let i = index" class="single-note">
                    <div class="note-list-header">
                        <!-- author and date -->
                        <div class="user-info">
                            <div class="picture">
                                <img *ngIf="note?.creation_user?.image?.file"
                                    [src]="note?.creation_user?.image?.file | isAuthImage | async" class="pic" />
                                <mat-icon *ngIf="!note?.creation_user?.image?.file" svgIcon="user"
                                    class="pic icon mat-24"></mat-icon>
                            </div>
                            <div>
                                <div class="is-subtitle1" style="font-weight: 500; color: #000000">
                                    {{note?.creation_user?.str || note?.creation_user?.last_name}}
                                </div>
                                <div class="is-caption" *ngIf="note?.update_datetime === note?.creation_datetime">
                                    {{'creation_on' | translate}} {{note?.creation_datetime_formatted}}
                                </div>
                                <div class="is-caption" *ngIf="note?.update_datetime !== note?.creation_datetime">
                                    {{'edit_on' | translate}} {{note?.update_datetime_formatted}}
                                </div>
                            </div>
                        </div>
                        <!-- options button -->
                        <div class="option-button-container">
                            <button class="reffered-icon"
                                *ngIf="dataExperienceGeneralNotes && note?.entity === 'dataxp'" mat-icon-button
                                [matTooltip]="'referred_to_data_experience' | translate"
                                (click)="changeRefferedTo(note, 'site')"
                                [disabled]="!checkPermission('dataexperience.change_note')">
                                <mat-icon [svgIcon]="'dashboard'"></mat-icon>
                            </button>
                            <button class=" reffered-icon" *ngIf="dataExperienceGeneralNotes && note?.entity === 'site'"
                                mat-icon-button [matTooltip]="'referred_to_site' | translate"
                                (click)="changeRefferedTo(note, 'dataxp')"
                                [disabled]="!checkPermission('dataexperience.change_note')">
                                <mat-icon [svgIcon]="'Site_icon'"></mat-icon>
                            </button>

                            <button *ngIf="dataExperienceGeneralNotes && note?.pinned" mat-icon-button
                                class="margin-right-button" color="primary" [matTooltip]="this.highlightedNotes"
                                (click)="changeHighlighted(note)"
                                [disabled]="!checkPermission('dataexperience.change_note')">
                                <mat-icon [svgIcon]="'pin'"></mat-icon>
                            </button>
                            <button *ngIf="dataExperienceGeneralNotes && !note?.pinned" mat-icon-button
                                class="margin-right-button" color="primary" [matTooltip]="this.highlightedNotes"
                                (click)="changeHighlighted(note)"
                                [disabled]="!checkPermission('dataexperience.change_note')">
                                <mat-icon [svgIcon]="'un_pin'"></mat-icon>
                            </button>

                            <ng-container
                                *ngIf="checkPermission('dataexperience.change_note') || checkPermission('dataexperience.delete_note')">
                                <button mat-icon-button color="#00000099"
                                    #highlightedOptionMenuTrigger="matMenuTrigger"
                                    [matMenuTriggerFor]="highlightedViewOptions">
                                    <mat-icon [svgIcon]="'other_vert'"></mat-icon>
                                </button>
                            </ng-container>
                            <mat-menu #highlightedViewOptions="matMenu" class="note-option-panel">
                                <ng-container *ngIf="checkPermission('dataexperience.change_note')">
                                    <button mat-menu-item (click)="editNote($event, note)">
                                        <span class="is-body2 single-option">{{'edit'| translate}}</span>
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="checkPermission('dataexperience.delete_note')">
                                    <button mat-menu-item (click)="deleteNote($event, note)">
                                        <span class="is-body2 single-option">{{'delete'| translate}}</span>
                                    </button>
                                </ng-container>
                            </mat-menu>
                        </div>
                    </div>

                    <!-- note content -->
                    <ng-container *ngIf="!note.isEdit">
                        <div class="single-note-content" style="margin-bottom: 10px;">
                            <quill-editor [(ngModel)]="note.text" readOnly="true" [modules]="quillConfigReadOnly">
                            </quill-editor>
                        </div>

                        <div class="is-body2" style="padding-bottom: 15px" class="valid-container">
                            <mat-icon [svgIcon]="'time'"
                                style="color: #989898; width: 20px; height: 20px;"></mat-icon>
                            <span class="is-body2">{{'note_valid' | translate}} </span>
                            <ng-container *ngIf="note?.valid_from !== null || note?.valid_to !== null">
                                <ng-container *ngIf="note?.valid_from !== null">
                                    <span class="is-body2"> {{'from' | translate | lowercase}} </span>
                                    <span class="is-body2" style="color: #000000">{{note?.valid_from_formatted}}</span>
                                </ng-container>
                                <ng-container *ngIf="note?.valid_from === null">
                                    <span class="is-body2"> {{'from' | translate | lowercase}} </span>
                                    <span class="is-body2" style="color: #000000">{{'always' | translate |
                                        lowercase}}</span>
                                </ng-container>
                                <ng-container *ngIf="note?.valid_to !== null">
                                    <span class="is-body2"> {{'to' | translate | lowercase}} </span>
                                    <span class="is-body2" style="color: #000000">{{note?.valid_to_formatted}}</span>
                                </ng-container>
                                <ng-container *ngIf="note?.valid_to === null">
                                    <span class="is-body2"> {{'to' | translate | lowercase}} </span>
                                    <span class="is-body2" style="color: #000000">{{'always' | translate |
                                        lowercase}}</span>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="note?.valid_from === null && note?.valid_to === null">
                                <span *ngIf="note?.valid_from === null" class="is-body2" style="color: #000000">
                                    {{'always' | translate | lowercase}}
                                </span>
                            </ng-container>
                        </div>
                    </ng-container>

                    <!-- note content when edit -->
                    <ng-container *ngIf="checkPermission('dataexperience.change_note')">
                        <ng-container *ngIf="note.isEdit">
                            <div class="single-note-content-edit">
                                <quill-editor #editEditor [(ngModel)]="note.newText"
                                    placeholder="{{ 'note_dataXp_placeholder' | translate }}" [modules]="quillConfig"
                                    [required]="true">
                                </quill-editor>
                            </div>

                            <!-- period -->
                            <div class="period-container">
                                <div class="is-body2">{{'view_note_data_experience' | translate}}</div>
                                <!-- from -->
                                <span class="is-body2">{{'from' | translate | lowercase}}</span>
                                <mat-form-field appearance="outline"
                                    style="width: 33%; margin-right: 10px; margin-left: 10px; margin-bottom: 5px;">
                                    <input matInput class="is-body2" [matDatepicker]="fromPicker"
                                        placeholder="{{ 'always' | translate | lowercase }}"
                                        [formControl]="note.dateFrom" autocomplete="off" [max]="note?.dateTo?.value">
                                    <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #fromPicker></mat-datepicker>
                                </mat-form-field>
                                <ng-container *ngIf="note?.dateFrom?.value !== null">
                                    <mat-form-field appearance="outline"
                                        style="width: 33%; margin-right: 24%; margin-bottom: 5px;">
                                        <input matInput [formControl]="note.timeFrom" placeholder="00:00"
                                            mask="00:m0" />
                                    </mat-form-field>
                                </ng-container>
                                <!-- to -->
                                <span class="is-body2"> {{'to' | translate | lowercase}}</span>
                                <mat-form-field appearance="outline"
                                    style="width: 33%; margin-right: 10px; margin-left: 10px;">
                                    <input matInput class="is-body2" [matDatepicker]="toPicker"
                                        placeholder="{{ 'always' | translate | lowercase }}" [formControl]="note.dateTo"
                                        autocomplete="off" [min]="note?.dateFrom?.value">
                                    <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #toPicker></mat-datepicker>
                                </mat-form-field>
                                <ng-container *ngIf="note.dateTo.value !== null">
                                    <mat-form-field appearance="outline" style="width: 33%; margin-right: 10px;">
                                        <input matInput [formControl]="note.timeTo" placeholder="23:59"
                                            mask="00:m0" />
                                    </mat-form-field>
                                </ng-container>
                            </div>

                            <!-- actions -->
                            <div class="buttons-container" style="padding-bottom: 15px">
                                <button mat-button color="primary" class="view-note-button" style="margin-right: 20px;"
                                    (click)="cancel($event, note)">
                                    <span>{{'cancel' | translate | uppercase}}</span>
                                </button>
                                <button mat-flat-button color="primary" class="view-note-button"
                                    [disabled]="setSubmitDisabled(note)" (click)="submit($event, note)">
                                    <span>{{'save' | translate | uppercase}}</span>
                                </button>
                            </div>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="noteListHighlighted.length - 1 !== i">
                        <mat-divider style="margin-bottom: 15px;"></mat-divider>
                    </ng-container>
                </div>
            </div>
            <mat-divider class="divider-highlighted"></mat-divider>
        </ng-container>

        <!-- general notes list -->
        <ng-container *ngIf="noteListGeneral.length !== 0 && dataExperienceGeneralNotes">
            <div class="notes-header">
                <span class="is-subtitle1" style="font-weight: 500; color: #000000;">{{'notes' | translate}}</span>
            </div>
            <!-- <mat-divider class="divider-highlighted"></mat-divider> -->
        </ng-container>
        <div style="margin-bottom: 15px;">
            <div *ngFor="let note of noteListGeneral; let i = index" class="single-note">
                <div class="note-list-header">
                    <!-- author and date -->
                    <div class="user-info">
                        <div class="picture">
                            <img *ngIf="note?.creation_user?.image?.file"
                                [src]="note?.creation_user?.image?.file | isAuthImage | async" class="pic" />
                            <mat-icon *ngIf="!note?.creation_user?.image?.file" svgIcon="user"
                                class="pic icon mat-24"></mat-icon>
                        </div>
                        <div>
                            <div class="is-subtitle1" style="font-weight: 500; color: #000000">
                                {{note?.creation_user?.str || note?.creation_user?.last_name}}
                            </div>
                            <div class="is-caption" *ngIf="note?.update_datetime === note?.creation_datetime">
                                {{'creation_on' | translate}} {{note?.creation_datetime_formatted}}
                            </div>
                            <div class="is-caption" *ngIf="note?.update_datetime !== note?.creation_datetime">
                                {{'edit_on' | translate}} {{note?.update_datetime_formatted}}
                            </div>
                        </div>
                    </div>
                    <!-- options button -->
                    <div class="option-button-container">
                        <button class="reffered-icon" *ngIf="dataExperienceGeneralNotes && note?.entity === 'dataxp'"
                            mat-icon-button [matTooltip]="'referred_to_data_experience' | translate"
                            (click)="changeRefferedTo(note, 'site')"
                            [disabled]="!checkPermission('dataexperience.change_note')">
                            <mat-icon [svgIcon]="'dashboard'"></mat-icon>
                        </button>
                        <button class=" reffered-icon" *ngIf="dataExperienceGeneralNotes && note?.entity === 'site'"
                            mat-icon-button [matTooltip]="'referred_to_site' | translate"
                            (click)="changeRefferedTo(note, 'dataxp')"
                            [disabled]="!checkPermission('dataexperience.change_note')">
                            <mat-icon [svgIcon]="'Site_icon'"></mat-icon>
                        </button>

                        <button *ngIf="dataExperienceGeneralNotes && note?.pinned" mat-icon-button
                            class="margin-right-button" color="primary" [matTooltip]="this.highlightedNotes"
                            (click)="changeHighlighted(note)"
                            [disabled]="!checkPermission('dataexperience.change_note')">
                            <mat-icon [svgIcon]="'pin'"></mat-icon>
                        </button>
                        <button *ngIf="dataExperienceGeneralNotes && !note?.pinned" mat-icon-button
                            class="margin-right-button" color="primary" [matTooltip]="this.highlightedNotes"
                            (click)="changeHighlighted(note)"
                            [disabled]="!checkPermission('dataexperience.change_note')">
                            <mat-icon [svgIcon]="'un_pin'"></mat-icon>
                        </button>

                        <ng-container
                            *ngIf="checkPermission('dataexperience.change_note') || checkPermission('dataexperience.delete_note')">
                            <button mat-icon-button color="#00000099" #generalOptionMenuTrigger="matMenuTrigger"
                                [matMenuTriggerFor]="generalViewOptions">
                                <mat-icon [svgIcon]="'other_vert'"></mat-icon>
                            </button>
                            <mat-menu #generalViewOptions="matMenu" class="note-option-panel">
                                <ng-container *ngIf="checkPermission('dataexperience.change_note')">
                                    <button mat-menu-item (click)="editNote($event, note)">
                                        <span class="is-body2 single-option">{{'edit'| translate}}</span>
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="checkPermission('dataexperience.delete_note')">
                                    <button mat-menu-item (click)="deleteNote($event, note)">
                                        <span class="is-body2 single-option">{{'delete'| translate}}</span>
                                    </button>
                                </ng-container>
                            </mat-menu>
                        </ng-container>
                    </div>
                </div>

                <!-- note content -->
                <ng-container *ngIf="!note.isEdit">
                    <div class="single-note-content">
                        <quill-editor #editEditor [(ngModel)]="note.text" readOnly="true"
                            [modules]="quillConfigReadOnly">
                        </quill-editor>
                    </div>

                    <div class="is-body2" class="valid-container">
                        <mat-icon [svgIcon]="'time'"
                            style="color: #989898; width: 20px; height: 20px;"></mat-icon>
                        <span class="is-body2">{{'note_valid' | translate}} </span>
                        <ng-container *ngIf="note?.valid_from !== null || note?.valid_to !== null">
                            <ng-container *ngIf="note?.valid_from !== null">
                                <span class="is-body2"> {{'from' | translate | lowercase}} </span>
                                <span class="is-body2" style="color: #000000">{{note?.valid_from_formatted}}</span>
                            </ng-container>
                            <ng-container *ngIf="note?.valid_from === null">
                                <span class="is-body2"> {{'from' | translate | lowercase}} </span>
                                <span class="is-body2" style="color: #000000">{{'always' | translate |
                                    lowercase}}</span>
                            </ng-container>
                            <ng-container *ngIf="note?.valid_to !== null">
                                <span class="is-body2"> {{'to' | translate | lowercase}} </span>
                                <span class="is-body2" style="color: #000000">{{note?.valid_to_formatted}}</span>
                            </ng-container>
                            <ng-container *ngIf="note?.valid_to === null">
                                <span class="is-body2"> {{'to' | translate | lowercase}} </span>
                                <span class="is-body2" style="color: #000000">{{'always' | translate |
                                    lowercase}}</span>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="note?.valid_from === null && note?.valid_to === null">
                            <span *ngIf="note?.valid_from === null" class="is-body2" style="color: #000000">
                                {{'always' | translate | lowercase}}
                            </span>
                        </ng-container>
                    </div>
                </ng-container>

                <!-- note content when edit -->
                <ng-container *ngIf="checkPermission('dataexperience.change_note')">
                    <ng-container *ngIf="note.isEdit">
                        <div class="single-note-content-edit">
                            <quill-editor [(ngModel)]="note.newText"
                                placeholder="{{ 'note_dataXp_placeholder' | translate }}" [modules]="quillConfig"
                                [required]="true">
                            </quill-editor>
                        </div>

                        <!-- period -->
                        <div class="period-container">
                            <div class="is-body2" style="margin-bottom: 5px;">{{'view_note_data_experience' |
                                translate}}
                            </div>
                            <!-- from -->
                            <span class="is-body2">{{'from' | translate | lowercase}}</span>
                            <mat-form-field appearance="outline"
                                style="width: 33%; margin-right: 10px; margin-left: 10px; margin-bottom: 5px;">
                                <input matInput class="is-body2" [matDatepicker]="fromGeneralPicker"
                                    placeholder="{{ 'always' | translate | lowercase }}" [formControl]="note.dateFrom"
                                    autocomplete="off" [max]="note?.dateTo?.value">
                                <mat-datepicker-toggle matSuffix [for]="fromGeneralPicker"></mat-datepicker-toggle>
                                <mat-datepicker #fromGeneralPicker></mat-datepicker>
                            </mat-form-field>
                            <ng-container *ngIf="note.dateFrom.value !== null">
                                <mat-form-field appearance="outline"
                                    style="width: 33%; margin-right: 24%; margin-bottom: 5px;">
                                    <input matInput [formControl]="note?.timeFrom" placeholder="00:00" mask="00:m0" />
                                </mat-form-field>
                            </ng-container>
                            <!-- to -->
                            <span class="is-body2" style="margin-right: 8px;"> {{'to' | translate | lowercase}}</span>
                            <mat-form-field appearance="outline"
                                style="width: 33%; margin-right: 10px; margin-left: 10px;">
                                <input matInput class="is-body2" [matDatepicker]="toGeneralPicker"
                                    placeholder="{{ 'always' | translate | lowercase }}" [formControl]="note.dateTo"
                                    autocomplete="off" [min]="note?.dateFrom?.value">
                                <mat-datepicker-toggle matSuffix [for]="toGeneralPicker"></mat-datepicker-toggle>
                                <mat-datepicker #toGeneralPicker></mat-datepicker>
                            </mat-form-field>
                            <ng-container *ngIf="note.dateTo.value !== null">
                                <mat-form-field appearance="outline" style="width: 33%; margin-right: 10px;">
                                    <input matInput [formControl]="note?.timeTo" placeholder="23:59" mask="00:m0" />
                                </mat-form-field>
                            </ng-container>
                        </div>

                        <!-- actions -->
                        <div class="buttons-container">
                            <button mat-button color="primary" class="view-note-button" style="margin-right: 20px;"
                                (click)="cancel($event, note)">
                                <span>{{'cancel' | translate | uppercase}}</span>
                            </button>
                            <button mat-flat-button color="primary" class="view-note-button"
                                [disabled]="setSubmitDisabled(note)" (click)="submit($event, note)">
                                <span>{{'save' | translate | uppercase}}</span>
                            </button>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="noteListGeneral.length - 1 !== i">
                    <mat-divider style="margin-bottom: 15px; margin-top: 15px;"></mat-divider>
                </ng-container>
            </div>
        </div>
    </div>
</div>